// extracted by mini-css-extract-plugin
export default {"skeleton":"styles_skeleton__kxCMm","loadingSkeleton":"styles_loadingSkeleton__vFx8T"};